import '@/styles/index.css'

import { createApp } from 'vue'
import App from '@/App.vue'
import router from "@/router";
import { captureRedirectAttributionFromUrl } from '@/practice/redirectAttribution'
import { recordProductFunnelFirstVisit } from '@/practice/productFunnel'
import { initializeTheme } from '@/composables/useTheme'
import { isLogoutRedirectInProgress, setAuthenticationFailureHandler } from '@/practice/authSession'
import { startPageLoadRequests } from '@/practice/api'
import { loadLanguageAsync } from '@/languages/messages'
import { getDefaultSourceLanguage } from '@/practice/util'

import { initializeTrackingConsent } from '@/practice/trackingConsent'
const normalizedPath = window.location.pathname.replace(/\/+$/, '')
const isMarketingLink = ['/marketing-feedback', '/marketing-unsubscribe'].includes(normalizedPath)

// Same paths as the ChatView preload in vite.config.ts, minus invite links,
// which record the invite click before asking for the user.
if (['/', '/chat', '/practice', '/stats', '/settings'].includes(normalizedPath || '/') && !isLogoutRedirectInProgress()) {
  startPageLoadRequests()
  void loadLanguageAsync(getDefaultSourceLanguage())
}

if (!isMarketingLink) {
  initializeTrackingConsent()
}

captureRedirectAttributionFromUrl()
if (!isMarketingLink && !isLogoutRedirectInProgress()) {
  void recordProductFunnelFirstVisit()
}
initializeTheme()
setAuthenticationFailureHandler(() => {
  const path = router.currentRoute.value.path
  if (path.startsWith('/i/') || path === '/login') {
    return
  }
  void router.replace('/login')
})
document.body.style.visibility = 'visible';
const app = createApp(App)
app.use(router)
app.mount('#app')
